<div class="site-card">
  @if (site) {
    <img class="site-background" [src]="site.imageUrl" [alt]="site.name" />

    <div class="site-overlay"></div>

    <div class="site-content">
      <div class="site-label">CUSTOMER SITE</div>

      <div class="site-name">
        <span class="location-icon">
          <mat-icon>location_on</mat-icon>
        </span>

        <span>
          {{ site.name }}
        </span>
      </div>

      <div class="site-address">
        {{ site.address }}
      </div>
    </div>
  } @else {
    <div class="site-empty">
      <span>No site information</span>
    </div>
  }
</div>
